import * as amplitude from '@amplitude/analytics-browser'

interface AmplitudeConfig {
  apiKey: string
  options: {
    serverZone?: 'EU' | 'US'
    autocapture?: boolean
    fetchRemoteConfig?: boolean
    sessionReplay?: {
      sampleRate: number
    }
  }
}

export const initializeAmplitude = (): void => {
  const isProduction = process.env.VUE_APP_ENV_MODE === 'production'

  const config: AmplitudeConfig = {
    apiKey: isProduction ? '2cd1e6bd44c33fe6e3a719e25fdc4dd9' : '18576979e151a4cb82782024bd0ecf20',
    options: {
      serverZone: 'EU',
      autocapture: true,
      fetchRemoteConfig: true,
      sessionReplay: {
        sampleRate: isProduction ? 1 : 0.1,
      },
    },
  }

  amplitude.init(config.apiKey, config.options)
}

export const identifyUser = (userId: string, userProperties: Record<string, any> = {}): void => {
  amplitude.setUserId(userId)
  amplitude.setGroup('dealer', userProperties.dealer)
}

export const amplitudeInstance = amplitude
